import { Pipe, PipeTransform } from '@angular/core';
import { LocalizedText } from '../items/models/item-response-model-v2';

@Pipe({ name: 'enGbText', standalone: true })
export class EnGbTextPipe implements PipeTransform {
    transform(texts: Array<LocalizedText> | null | undefined): string {
        return texts?.find(t => t.languageCode === 'en-gb')?.value ?? '';
    }
}
